/** Safely parse JSON (or text) without crashing on empty/invalid bodies */
/**
 *
 * @param {*} response  HTTP Response to process
 * @returns {string}    json response or text response
 */
export async function parseResponseBody(response) {
  const ct = response.headers.get("content-type") || "";
  if (response.status === 204) return null; // No Content
  const raw = await response.text();
  if (!raw) return null;
  if (ct.includes("application/json")) {
    try {
      return await JSON.parse(raw);
    } catch {
      return raw;
    }
  }
  return raw;
}
